import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { safeValue, ConfigService, buildPath } from '@identic/core';
import { BaseService } from '@identic/api';
import { DiagnosisViewModel, DIAGNOSIS_DISPLAY_FIELD } from './+state';
import { DiagnosisConstants } from './data-access.constants';

// R(oute)T(oken)
const RT = DiagnosisConstants;

@Injectable({providedIn: 'root'})
export class DiagnosisService extends BaseService<DiagnosisViewModel> {

  constructor(http: HttpClient, config: ConfigService) {
    super(http, buildPath(config.environment.API_BASE_URL, safeValue(config, 'environment.Api.Diagnosis', RT.defaultApi)), DIAGNOSIS_DISPLAY_FIELD);
  }
}
